import React from 'react';

import { getAuthErrorTitle, getAuthErrorText } from './authErrorCodes';

const AuthErrorAlert = ({ isAuthLoading = false, error = {} }) => {
    const title = getAuthErrorTitle(error);
    const text = getAuthErrorText(error);

    return (
        <div className='error-alert-box'>
            <div className='error-alert'>
                {isAuthLoading
                    ? ''
                    : <React.Fragment>
                        <div className='error-alert-title'>{title}</div>
                        <div className='error-alert-text'>{text}</div>

                    </React.Fragment>
                }
            </div>
        </div>
    )
};

export default AuthErrorAlert;